import firebase from "firebase"

export default {
   name: 'SignUp',
   data() {
      return {
         email         : '',
         password      : '',
         passwordRepeat: ''
      }
   },
   methods: {
      signUp() {
         let admins = ['adrianmoviles14@gmail.com', 'priscillaparedesosorio@gmail.com','Kiaralexandra49@gmail.com','yanhezv@gmail.com']
         let isAdmin = admins.indexOf(this.email) != -1

         firebase.auth().createUserWithEmailAndPassword(this.email,this.password)
            .then((response) => {
               if (isAdmin) {
                  let user = {
                     email : response.user.email,
                     userId: response.user.uid
                  }
                  this.message(1, 'Bienvenido usuario administrador.')
                  this.$store.dispatch('userSystem', user)
                  this.$router.replace('intranet')
               } else {
                  this.message(1, 'Gracias por registrarse ingrese a la aplicación.')
                  firebase.auth().signOut().then(() => {
                     this.$router.replace('login')
                  })
               }
            })
            .catch((error) => {
               this.message(0, error.message)
            })
      },
      message(status,text) {
         this.$q.notify({
            type: status == 1 ? 'positive' : 'negative',
            message: text,
            position: 'top-right'
         })
      }
   }
}
